export type Tabs =
  | 'Account approvals'
  | 'Pending invites'
  | 'Missing beneficiaries'
  | 'Pending ACATS'
  | 'Failed ACATS'
  | 'ACATS Approvals'
  | 'Outstanding RMDs'
  | 'Onboarding lockouts';
export type Paths =
  | '/co_pilot/account_approvals'
  | '/co_pilot/pending_invites'
  | '/co_pilot/missing_beneficiaries'
  | '/co_pilot/pending_acats'
  | '/co_pilot/failed_acats'
  | '/co_pilot/acats_approvals'
  | '/co_pilot/rmds'
  | '/co_pilot/account_lockouts';
export const LIMIT = 10;

export interface ActionRequestParams {
  itemIds: string[];
  itemsBefore: string;
}

export interface CoPilotResponseMeta {
  lastPage: boolean;
  retrievedAt: string;
}
